module.exports = __webpack_public_path__ + "img/tie-1.bf2d124d.svg";